import { render } from "./index.vue?vue&type=template&id=73986222&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=73986222&lang=scss&scoped=true"

import exportComponent from "/data/jenkins-workspace/workspace/Publicar_automáticamente_por_Lianxin/联心数字化工作站pc前端【生产】/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73986222"]])

export default __exports__